import React from 'react';
import { bool, shape, string } from 'prop-types';

const SprayColor = ({
  className = '',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.8745 9H10.1245L11.1573 11.735C11.3426 12.2256 10.9801 12.75 10.4557 12.75H7.54409C7.01978 12.75 6.65728 12.2258 6.84239 11.7352L7.8745 9ZM8.6245 10.5L8.2495 11.25H9.7495L9.3745 10.5H8.6245Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M8.2495 17.25L8.2495 14.25H9.7495L9.7495 17.25H8.2495Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M11.8736 15.7881L10.6255 13.916L11.8736 13.084L13.1216 14.9561L11.8736 15.7881Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M4.8774 14.9561L6.12548 13.084L7.37355 13.916L6.12548 15.7881L4.8774 14.9561Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M3.8915 2.68659C3.53617 2.19027 3.89092 1.5 4.50132 1.5H13.4975C14.1079 1.5 14.4626 2.19025 14.1073 2.68658L10.1245 8.25H7.8745L3.8915 2.68659ZM5.95677 3L8.63534 6.75H9.36341L12.042 3H5.95677Z" fill="currentColor" />
  </svg>
);

SprayColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default SprayColor;
